export const ADD_FLASH_MESSAGE = "ADD_FLASH_MESSAGE";
export const DELETE_FLASH_MESSAGE = "DELETE_FLASH_MESSAGE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CONTACT_INFO = "SET_CONTACT_INFO";
export const SET_MUTE = "SET_MUTE";
export const SET_AUTOASSIGN = "SET_AUTOASSIGN";
export const SET_FULLSTORY = "SET_FULLSTORY";
export const SET_LEAD_PROCESS_STATUS = "SET_LEAD_PROCESS_STATUS";
export const SET_RELOAD_REPLY = "SET_RELOAD_REPLY";
export const SET_LIVE_LEAD_COUNT = "SET_LIVE_LEAD_COUNT";
